import { useState } from "react";

const SelectionScreen = ({ onSelect }) => {
  const [hovered, setHovered] = useState(null);
  const cards = [
    {
      id: "slider",
      icon: "🎚️",
      title: "Slider Control",
      desc: "Use per-joint sliders with a live 2D diagram. Precise, fast, and intuitive.",
      tags: ["6 DOF sliders", "Live diagram", "Precise input"],
      accent: "#3B82F6",
      bg: "#eff6ff",
      tagBg: "#dbeafe",
      tagColor: "#1d4ed8",
    },
    {
      id: "3d",
      icon: "🦾",
      title: "3D Model",
      desc: "Interact with a 3D arm directly using mouse drag. Visual and spatial.",
      tags: ["Mouse drag", "3D viewport", "Spatial control"],
      accent: "#8B5CF6",
      bg: "#f5f3ff",
      tagBg: "#ede9fe",
      tagColor: "#6d28d9",
      badge: "BETA",
    },
  ];

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 48px", gap: 28 }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", marginBottom: 6 }}>Choose Control Mode</div>
        <div style={{ fontSize: 13, color: "#64748b" }}>How would you like to position the robotic arm?</div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, width: "100%", maxWidth: 580 }}>
        {cards.map((c) => (
          <button key={c.id} onClick={() => onSelect(c.id)}
            onMouseEnter={() => setHovered(c.id)} onMouseLeave={() => setHovered(null)}
            style={{
              background: hovered === c.id ? c.bg : "white",
              border: `2px solid ${hovered === c.id ? c.accent : "#e2e8f0"}`,
              borderRadius: 16, padding: "28px 22px", cursor: "pointer", textAlign: "left",
              display: "flex", flexDirection: "column", gap: 14,
              transition: "all 0.18s",
              boxShadow: hovered === c.id ? `0 8px 28px ${c.accent}22` : "0 1px 4px rgba(0,0,0,0.05)",
              transform: hovered === c.id ? "translateY(-3px)" : "translateY(0)",
              position: "relative",
            }}>
            {c.badge && (
              <span style={{ position: "absolute", top: 12, right: 12, fontSize: 9, background: c.tagBg, color: c.accent, borderRadius: 20, padding: "2px 8px", fontWeight: 700, letterSpacing: 0.5 }}>{c.badge}</span>
            )}
            <div style={{ width: 52, height: 52, background: c.bg, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, border: `1px solid ${c.accent}33` }}>{c.icon}</div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#0f172a", marginBottom: 5 }}>{c.title}</div>
              <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>{c.desc}</div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
              {c.tags.map(t => (
                <span key={t} style={{ fontSize: 10, background: c.tagBg, color: c.tagColor, borderRadius: 20, padding: "3px 9px", fontWeight: 600 }}>{t}</span>
              ))}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 4, fontSize: 12, fontWeight: 600, color: c.accent, marginTop: -4 }}>
              Select <span>→</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectionScreen;